import React, {useState} from 'react';
import {Button, Table} from 'react-bootstrap';
import './BuildingInfo.css';
import DoorIcon from "../../assets/doorIcon.png";
import RunningCheck from "../../assets/runningCheck.png";
import CloseEventsButton from "../../assets/close_events.png";
import ViewEventModal from './ViewEventModal.js';
import {useNavigate} from 'react-router-dom';
import ROUTES from "../../../utils/constants/endpoints";
import CloseButton from "../CloseButton/CloseButton";

const BuildingInfo = ({ data, onClose, handleDeviceClick }) => {
    const [applyTransparentStyle, setApplyTransparentStyle] = useState(true);
    const [viewModalShow, setViewModalShow] = React.useState(false);
    const navigate = useNavigate()
    
    const isBuilding = !data.device;

    const handleHideCards = () => {
        handleDeviceClick(null)
        setApplyTransparentStyle(false);
    };

    const handleGuardedTypeClick = (device) => {
        setApplyTransparentStyle(true);
        handleDeviceClick(device);
    };

    const handleViewClose = () => {
        setViewModalShow(false);
    };

    const numOfDevices = data.building.bankInfos?.reduce((total, bank) => total + (bank.deviceInfos?.length || 0), 0) || 0;
    const selectedDeviceEvents = data.device?.deviceEvents;

    // Format time stamp
    const formatTimestamp = (timestamp) => {
        const date = new Date(timestamp);
        const dateString = date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        });
        const timeString = date.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true,
        });
        return `${dateString} ${timeString}`;
    };

    const handleViewAllClick = () => {
        navigate(ROUTES.EVENTS);
    }
    return (
        <div className="device-info-main-container">
            <div className="d-flex justify-content-end pb-4">
                <CloseButton theme='dark' onClick={onClose}/>
            </div>
            <div className='device-info-small-container'>
                <div className="p-3 pb-0">
                    <h2>{data.building.buildingName}</h2>
                    <p className='fs-5'>{numOfDevices} Devices</p>
                </div>
                <div className='card-1 d-flex flex-column align-items-start align-items-lg-center flex-lg-row gap-3'>
                    {numOfDevices > 0 && (data.building.bankInfos?.flatMap(bank => bank.deviceInfos) || []).map(device => (
                        <div
                            key={device.deviceId}
                            className={`${device.deviceId === data.device ? 'current-device' : applyTransparentStyle ? 'transparent-device' : ''
                                }`}
                        >
                            {device.deviceName}<br />
                            {device.contractor}
                            <div className='guarded-type' onClick={() => handleGuardedTypeClick(device)}>
                                <div className='guarded-1 pt-0.5 ps-0.5'>
                                    {device.status === 10 ? (
                                        <>
                                            <h5>Offline</h5>
                                        </>
                                    ) : device.status === 20 ? (
                                        <>
                                            <h5>Running</h5>
                                        </>
                                    ) : device.status === 30 ? (
                                        <>
                                            <h5>Guarded</h5>
                                        </>
                                    ) : device.status === 40 ? (
                                        <>
                                            <h5>Alarm</h5>
                                        </>
                                    ) : device.status === 50 ? (
                                        <>
                                            <h5>Emergency</h5>
                                        </>
                                    ) : device.status === 60 ? (
                                        <>
                                            <h5>Shutdown</h5>
                                        </>
                                    ) : (
                                        <h5>{device.status}</h5>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {!!data.device && (<div className='card-2 d-flex justify-content-between'>
                    <div className='d-flex flex-column flex-lg-row jusify-content-center justify-content-md-start gap-3'>
                        <div className='d-flex gap-1'>
                            <img src={DoorIcon} alt="Door Icon" className="door-image" />
                            <div className='device-name'>
                                {data.device?.deviceName}
                                <div id='elevator'>
                                    <h5>{data.device?.deviceType}</h5>
                                </div>
                            </div>
                        </div>

                        <div className='guarded-3'>
                            {data.device?.status === 10 ? (
                                <>
                                    <h3>Offline</h3>
                                    <h5 className='status'>STATUS</h5>
                                </>
                            ) : data.device?.status === 20 ? (
                                <>
                                    <h3>Running</h3>
                                    <h5 className='status'>STATUS</h5>
                                </>
                            ) : data.device?.status === 30 ? (
                                <>
                                    <h3>Guarded</h3>
                                    <h5 className='status'>STATUS</h5>
                                </>
                            ) : data.device?.status === 40 ? (
                                <>
                                    <h3>Alarm</h3>
                                    <h5 className='status'>STATUS</h5>
                                </>
                            ) : data.device?.status === 50 ? (
                                <>
                                    <h3>Emergency</h3>
                                    <h5 className='status'>STATUS</h5>
                                </>
                            ) : data.device?.status === 60 ? (
                                <>
                                    <h3>Shutdown</h3>
                                    <h5 className='status'>STATUS</h5>
                                </>
                            ) : (
                                <h3>{data.device?.status}</h3>
                            )}
                        </div>
                    </div>

                    <div>
                        <Button variant="" className="btn-right" onClick={handleHideCards}>
                            <img src={CloseEventsButton} alt="close events" />
                        </Button>
                    </div>
                </div>
                )}

                {!!data.device && (<div className='card-3'>
                    <Table>
                        <thead>
                            <tr>
                                <th></th>
                                <th>
                                    <span className='event-description'>
                                        Event/Description
                                    </span>
                                </th>
                                <th>
                                    <span className='date'>Date</span>
                                </th>
                                <th>
                                    <span className='code'>Code</span>
                                </th>
                                <th>
                                    <Button className='btn-primary' onClick={handleViewAllClick}>VIEW ALL</Button>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {selectedDeviceEvents.map((event) => (
                                <tr key={event.id} className='table-card-record'>
                                    <td>
                                        <img src={RunningCheck} alt='running-check' className="runningCheck-image" />
                                    </td>
                                    <td style={{ textAlign: 'left', verticalAlign: 'middle', lineHeight: '1' }} className='text-wrap text-white'>
                                        <span>{event.description}</span>
                                    </td>
                                    <td style={{textAlign: 'left', verticalAlign: 'middle', lineHeight: '1.5' }} className='text-wrap text-white'>
                                        <span >{formatTimestamp(event.date)}</span>
                                    </td>
                                    <td style={{ verticalAlign: 'middle' }} className='text-wrap text-white'>
                                        <span>{event.code}</span>
                                    </td>
                                    <td style={{ verticalAlign: 'middle' }} className='text-white'>
                                        <span onClick={() => setViewModalShow(true)}><u>View</u></span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
                )}
            </div>
            <ViewEventModal
                show={viewModalShow}
                onHide={handleViewClose}
                {...selectedDeviceEvents}
            />
        </div>
    );
};
export default BuildingInfo;
